import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import SidebarRight from "../components/Sidebar-Right";
import { RULES_MENU as rulesMenu, RULES_SECTION_PARAM } from "../config/rules";
import "../styles/Rules.css"; // Assuming you have a CSS file for styling

const rulesContent = {
  tickets: (
    <section className="tickets">
    <h1>Tickets</h1>
    <h2>When should I create a ticket?</h2>
    <ul>
        <li>You have reasonable suspicion with <strong>evidence</strong> that someone is breaking a rule.</li>
        <li>You or someone you know is being bullied/harassed/threatened/doxxed by a member of the player base <strong>in-game</strong>.</li>
        <li>If you have knowledge of someone you know hacking/exploiting a glitch and would like to come forward.</li>
        <li>If you have encountered a glitch or issue with the server (It would be helpful if you can provide evidence or repeat the glitch).</li>
        <li>You have a <strong>reasonable</strong> question or concern that has not already been addressed in the rules or by asking staff in game. Please feel free to ask other members in the player base before approaching staff!</li>
        <li>If a player is performing misconduct in real-time on the server and it has not already been addressed.</li>
        <li>If you are having difficulties with purchases through our website store or have not received an item.</li>
    </ul>

    <h2>I have knowledge of someone breaking a rule intentionally:</h2>
    <ul>
        <li>If you have knowledge of a player or teammate hacking and would like to come forward make a ticket <strong>as soon as possible.</strong></li>
        <li><strong>Your identity will be protected</strong> at all costs and will not be released to the player that is being punished. (However, if the evidence you provide gives away your identity we are not responsible for the player figuring out who reported them in certain instances)</li>
        <li><strong>You will not be met by punishment</strong> if you come forward so long as you can prove you have not withheld the knowledge for an extended period of time.</li>
        <li><strong>Failure to report the knowledge</strong> will be met with punishment (Especially if there is proof you were knowingly playing with a player engaging in the act).</li>
    </ul>

    <h2>Staff Disclaimer:</h2>
    <ul>
        <li>Staff will address tickets as soon as possible, please consider that time zones and holidays may have an effect on when a ticket is opened.</li>
        <li>In some instances, it can take time when considering what has to be investigated. Gathering definitive evidence that a rule has been broken and proposing the appropriate punishment for the player may require some patience. We want to ensure all decisions are fair and justified.</li>
        <li>If you believe a staff member is engaging in harmful misconduct on the server and have proof please make a ticket and it will be handled promptly.</li>
    </ul>
    </section>

  ),
  chat: (
    <div>
      <h1>Chat conduct</h1>
      <section className="chat-rules">
        <h2>Chat Rules for both in game and on Discord</h2>
        <ul>
            <li><strong>Slurs and harmful language</strong> against race, gender, ethnic groups, sexuality, sexism, physical/mental disabilities, and mental illness <strong>will not be tolerated</strong>.</li>
            <li>Conversations surrounding topics such as sexual harassment, rape, domestic violence/abuse, child abuse, suicide, self harm, pedophilia, beastiality, porn, inappropriate roleplay, and conversations sexual in nature <strong>will not be tolerated</strong>.</li>
            <li>Cursing is allowed within reason, if you are harassing a player with continuous vulgar language you may be met with punishment. Bullying is not allowed.</li>
            <li>While we allow trash talk within reason, any disrespect towards staff will not be tolerated and will result in a punishment.</li>
            <li>Spamming is not allowed.</li>
            <li>If a player has asked you to stop messaging them and you continue to harass them you may be met with punishment.</li>
            <li>Threatening language towards players or staff including personal attacks, doxxing, threatening to release personal information, any form of blackmail, DDoS attacking, or pulling IP addresses will not be tolerated.</li>
            <li>Attempting to bypass words that are restricted will result in punishment.</li>
            <li>Political, religious, ideological, and controversial topics should not take place in public chat. You may talk about these in /msg or faction channels.</li>
            <li>English in all public chats, no special characters, or repetition of symbols/numbers</li>
            <li>All of these rules also apply to builds, books, signs, nametags, etc.</li>
            <li>Advertising other servers and promoting personal social media profiles is not allowed</li>
            <li>Targeting or harassing a player based on their age will not be tolerated. Please be mindful of what you say to minors. We take accusations of grooming seriously.</li>
            <li>No impersonation of players or staff via nickname or account name.</li>
        </ul>

        <h2>Exceptions for private in-game chat channels (i.e /msg or other related faction/ally/truce/party chats)</h2>
        <ul>
            <li>You may communicate in any language</li>
            <li>You have more freedom to discuss sensitive topics so long as they are not harmful, bigoted, sexual, or bullying.</li>
            <li>You may talk about other players so long as it does not involve any form of doxxing or revealing personal information. Conversation about other players should ONLY pertain to what is relevant to factions and the server itself.</li>
            <li>You are allowed to use vulgar language at your discretion so long as it is in compliance with the aforementioned chat rules (i.e no slurs, hate speech).</li>
        </ul>
        </section>

    </div>
    ),
    factions: (
    <section class="factions-rules">
  <h1>Factions</h1>
  <h3><em>(The following explains general rules of in-game play)</em></h3>

  <h2>Commonly asked questions</h2>
  <ul>
    <li><strong>Insiding a faction is allowed.</strong> Staff will not punish the player/players that insided nor give you the items you may have lost. It is your responsibility to vet your faction members and adjust faction permissions accordingly.</li>
    <li><strong>This is a WITHER raiding server.</strong> ISN Network does not have a cannon jar and it is highly advised to use withers to raid bases. TNT cannons will only have the same functions it would on vanilla minecraft.</li>
    <li>Yes, you can use <strong>1.8 PVP.</strong> As of right now the server is compatible with Java versions 1.8 - 1.21</li>
    <li><strong>Alts are allowed.</strong> There is no limit to the amount of alternate accounts you would like to use for grinding, insiding, etc. However, you may not use them to farm kills, impersonate other players, or ban/mute evade.</li>
    <li>Glitching/clipping into bases is not a legal means of raiding, anyone who has had value broken or been killed due to a successful attempt will be compensated.</li>
    <li>Glitching/clipping into the nether ceiling is not allowed.</li>
    <li><strong>Faction shields</strong> may only be used for <strong>10 hours of a 24 hour cycle</strong>, attempting to manipulate your shield in order to get extra protection within those 24 hours will result in disqualification of your faction's value for the remainder of the season.</li>
    <li><strong>Faction claims</strong> that border each other must have matching shields if they are allied, truced, and/or a faction that would be deemed as associated with the neighboring claim.</li>
    <li>Enemy claim blocking along a neighboring faction is allowed (even with a differing shield), so long as the claims are <strong>minimal</strong> and do not actively impede on the opportunity for other factions to raid. A clear and distinct unclaimed path must remain available to a base.</li>
    <li>If a faction is caught abusing shields/claim rules they will be addressed and action from the faction must be taken immediately in order to avoid staff intervention.</li>
    <li><strong>Failure to change shields/claims within an hour will result in staff taking action.</strong></li>
    <li>If you are unable to change the shield within the allotted hour (Example: You are the only member online and do not have perms) you must make a ticket so staff can do it for you. Failure to make a ticket will be considered negligence.</li>
    <li>No builds that are made of excessive entities/redstone to intentionally lag the server or other players.</li>
    <li>No book/shulker/nametag glitching to crash players.</li>
    <li><strong>Teleportation trapping is allowed</strong>, but not nether/end portal trapping.</li>
    <li className="Hacked-clients">Using <strong>hacked clients/mods/texture packs</strong> that offer an unfair advantage including (but not limited to):
      <ul className="Cheating-rules">
        <li>X-ray/Freecam</li>
        <li>Clear lava</li>
        <li>Anti-AFK</li>
        <li><strong>Kill-Aura/Anti-Knockback/Criticals/Bow aimbot</strong> (Any sort of PVP enhancer)</li>
        <li>Auto-Armour/Totem/XP bottles/Auto-build</li>
        <li><strong>Auto-clickers or any sort of AFK grinding mechanism</strong></li>
        <li><strong>ESP of any kind (Including: Entities/items/Chests)</strong></li>
        <li>Mini-maps/Mini-Player</li>
        <li><strong>Any sort of client that offers player location/tracks entities</strong></li>
        <li>Inventory-walk</li>
        <li>Flying/Jesus/Blink</li>
      </ul>
    </li>
  </ul>
</section>


    ),
    misc: (
    <section class="misc-rules">
  <h2>Misc. Rules</h2>
  <ul>
    <li>Ban Evasion and those aiding in the evasion will face punishment, potentially resulting in a perm-ban with no appeal.</li>
    <li>If you are insided/betrayed/killed you will not be reimbursed for your items by staff. Even if they are items you have bought in our online store via rank or crate key.</li>
    <li>All chat rules must be followed in our discord, images/memes/gifs/stickers must remain appropriate.</li>
    <li>Streaming and turning on your camera in the discord is done by choice. If you are doxxed or personal info gets leaked via stream you are at fault. Keep things appropriate and remember once your info is public we cannot help you or punish every player spreading it.</li>
    <li>All forms of social media attention are welcome. You may record and stream your experiences on the server. If you incriminate yourself through a video/livestream it will be handled like any other form of evidence.</li>
    <li>Video evidence provided by a player must be legit. Please include a timestamp or rough estimate of when the event took place so staff can look into it. Videos must be high enough resolution to be considered proof, they are not admissible if staff is unable to get a clear view.</li>
    <li>We do NOT allow account transfers at this time. (Exceptions could be made for extremely outstanding circumstances but we will need proof)</li>
  </ul>

  <p><strong>All rules are subject to change as the server continues to grow!</strong></p>
</section>

    ),
    disclaimer: (
    <section class="disclaimer">
    <h2>Disclaimer</h2>
    <p>
    ISN Network is not responsible for any bullying or harassment that takes place beyond the Minecraft server. We do not
    have jurisdiction over what happens in private discord messages or servers beyond our own. We do urge that you comply
    with discord TOS and we encourage players to report to discord if a player is not.
    </p>

    <p><em>
    *Certain exceptions will be made for more sensitive subjects that involve but are not limited to: unsolicited pornographic
    images, grooming, unsolicited sexual conversations, blackmail, and doxxing. (Our options of action to take even in these
    circumstances are limited beyond banning the player from the server).
    </em></p>

    <p>
    If you are being bullied and harassed outside of our server with a member of our player base it is up to you to block that
    person on discord.
    </p>

    <p>
    ISN Network is not responsible for dissatisfaction with online purchases. We do not offer refunds under any condition.
    Attempting to do so by charging back will result in a permanent ban.
    </p>
</section>

    ),
};

const Rules = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get(RULES_SECTION_PARAM);
  const isKnown = rulesMenu.some((item) => item.key === requested);
  const [active, setActive] = useState(
    isKnown ? requested : rulesMenu[0]?.key
  );

  // Deep links from the command palette arrive as ?section=tickets. An
  // unknown value falls back to the default section rather than rendering
  // nothing.
  useEffect(() => {
    if (isKnown && requested !== active) setActive(requested);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requested, isKnown]);

  const selectSection = (key) => {
    setActive(key);
    setSearchParams(key === rulesMenu[0].key ? {} : { [RULES_SECTION_PARAM]: key });
  };

  return (
    <div className="content">
      <Sidebar />
      <div className="main-content">
        <div className="rules-home">
        {active === "home" ? (
            <div className="rules-home">
          <h2>Welcome to ISNNETWORK's rules page!</h2>
        <p>All instances of rules being broken will be evaluated on a case-by-case basis.</p>
        <h2>Factors that will be considered when receiving a punishment will include:</h2>
        <ol>
            <li>The severity of the rule that has been broken</li>
            <li>A player's history of previous offenses</li>
            <li>If the action appears to be deliberate in nature</li>
        </ol>
        <p><strong>*Any offense could result in different punishments based on the above factors.</strong></p>
            </div>
        ) : (
          rulesContent[active]
        )}
      </div>
        </div>
      <SidebarRight
        title="Rules"
        menu={rulesMenu}
        active={active}
        setActive={selectSection}
      />
    </div>
  );
};

export default Rules;